import React from 'react';
import cx from 'classnames';
import { DefaultDecoration } from './InputField.decorators';
import InputFieldProps from './InputField.types';
import Input from '../../atoms/Input';
import styles from './InputField.module.scss';

/**
 * The InputField is a wrapper for an actual input field,
 * it ensure the accessibility rules of having an associated label
 */

const InputField = ({
  invalid,
  title,
  id,
  name,
  errorMessage,
  default: defaultValue,
  description,
  onChange,
  type,
  uiSchema,
  value,
  pointer,
  className,
  ariaHidden = false,
  dataCy,
}: InputFieldProps) => {
  // The component can be inferred via the properties provided by the schema
  const ComponentType = Input;

  if (!ComponentType) return null; // unable to find component
  // enforce an id
  const inputId = id || `id_${Math.floor(Math.random() * 1000) + 1}`;
  const errorMsgHolderId = `${inputId}_errorMsg`;

  const getInputElement = () => {
    return (
      <ComponentType
        name={name}
        id={inputId}
        defaultValue={defaultValue}
        onChange={onChange}
        label={title}
        value={value ?? ''}
        dataPointer={pointer}
        invalid={invalid}
        dataCy={dataCy}
        errorMsgHolderId={errorMsgHolderId}
        {...uiSchema?.properties}
        type={type}
      />
    );
  };

  const labelClasses: string = cx({
    [styles.label]: true,
    [styles.invalid]: invalid,
    [styles.isVisuallyHidden]: uiSchema?.properties?.hiddenLabel,
  });

  const InputEl = getInputElement();

  const isFullWidthComponent =
    uiSchema?.properties?.isFullWidth || uiSchema?.properties?.graphical || uiSchema?.properties?.icons !== undefined;

  return (
    <DefaultDecoration
      labelClasses={labelClasses}
      className={className}
      ariaHidden={ariaHidden}
      title={title}
      description={description}
      errorMessage={errorMessage}
      inputId={inputId}
      value={value}
      errorMsgHolderId={errorMsgHolderId}
      toolTip={uiSchema?.properties?.toolTip}
      isFullWidth={isFullWidthComponent}
      color={uiSchema?.properties?.color}
      hideError={uiSchema?.properties?.hideError}
      reducedMargin={uiSchema?.properties?.reducedMargin}
      noMargin={uiSchema?.properties?.noMargin}
      removeDescriptionMargin={uiSchema?.properties?.removeDescriptionMargin}>
      {InputEl}
    </DefaultDecoration>
  );
};

export default InputField;
